import React, { createContext, ReactNode, useContext, useState } from 'react'
import { Host } from '../models/hostModel';


interface HostPortalContextType {
    host: Host | undefined;
    setHost: (host: Host) => void;
}

const HostPortalContext = createContext<HostPortalContextType | undefined>(undefined);

export const HostPortalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [host, setHost] = useState<Host>();

    return (
        <HostPortalContext.Provider value={{ host, setHost }}>
            {children}
        </HostPortalContext.Provider>
    );
};

//custom hook to use the context
export const useHostPortalContext = (): HostPortalContextType => {
    const context = useContext(HostPortalContext);
    if(!context)
        throw new Error("useHostPortalContext must be used within a provider");

    return context;
}
